import { ITopicDetail } from "@/api/topics";
import { Button } from "@/components/shared/buttons/Button";
import { Panel } from "@/components/shared/Panel";
import { formatDate } from "@/utils";
import { Edit } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { useDialogs } from "@toolpad/core/useDialogs";
import { EditTopicDialog } from "../dialogs/EditTopicDialog";

interface IProps {
    topic: ITopicDetail;
}

export const TopicInfoSection = ({ topic }: IProps) => {
    const dialogs = useDialogs();

    const handleEdit = async () => {
        await dialogs.open(EditTopicDialog, { topic });
    };

    return (
        <Panel
            title="Topic Information"
            actions={
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<Edit fontSize="small" />}
                    onClick={handleEdit}
                    sx={{
                        color: (theme) => theme.palette.primary.contrastText,
                        borderColor: (theme) =>
                            theme.palette.primary.contrastText,
                        "&:hover": {
                            backgroundColor: (theme) =>
                                theme.palette.action.hover,
                        },
                        "& .MuiSvgIcon-root": {
                            fontSize: "1rem",
                        },
                    }}
                >
                    Edit
                </Button>
            }
        >
            <Stack spacing={2}>
                <InfoField label="ID" value={String(topic.id)} />
                <InfoField label="Name" value={topic.name} />
                <InfoField
                    label="Description"
                    value={topic.description || "-"}
                />
                <InfoField
                    label="Created At"
                    value={formatDate(topic.created_at)}
                />
                <InfoField
                    label="Updated At"
                    value={formatDate(topic.updated_at)}
                />
            </Stack>
        </Panel>
    );
};

interface IInfoFieldProps {
    label: string;
    value: string;
}

const InfoField = ({ label, value }: IInfoFieldProps) => (
    <Stack spacing={0.5}>
        <Typography variant="body2" color="textSecondary" fontWeight={500}>
            {label}
        </Typography>
        <Typography variant="body2">{value || "-"}</Typography>
    </Stack>
);
